module.exports = __webpack_public_path__ + "static/media/villa-rouse-360-preview.a07a46f2.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/villa-rouse-360-preview.JPG
// module id = 1156
// module chunks = 0